import {useRequest} from '@aboutyou/data-fetcher';
import {useHistory} from '@aboutyou/router';
import {useInViewEffect} from '@aboutyou/ui-components';
import {useEffect, useState} from 'react';

const PUSH_NOTIFICATION_SHOWN = 'push-notification-category-stream-shown';

export const usePushNotificationToggleShown = () => {
  const {location} = useHistory();

  const {data, updateCache} = useRequest<{
    shown: boolean | undefined;
  }>(
    PUSH_NOTIFICATION_SHOWN,
    () => ({
      shown: undefined,
    }),
    {
      disabled: true,
    },
  );

  const [initialShown, setInitialShown] = useState(data?.shown);

  // When navigating from a category page to a category page,
  // we need to sync back the session storage value
  // to prevent it from being shown across categories
  useEffect(() => {
    if (data?.shown) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setInitialShown(true);
    }
  }, [location.pathname, setInitialShown]);

  const {ref} = useInViewEffect<HTMLDivElement>(
    inView => {
      if (inView && !data?.shown) {
        updateCache({shown: true});
      }
    },
    {triggerOnce: true},
  );

  return {
    ref,
    wasShown: initialShown,
  };
};
